/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { ComplianceFrameworkRef } from '@ecsper/speciality-contract';

export const expertWitnessComplianceFrameworks: readonly ComplianceFrameworkRef[] = [
  {
    id: 'cpr-part-35',
    displayName: { 'en-GB': 'CPR Part 35 (England & Wales)' },
    version: '2024-04',
  },
] as const;
